require('./bootstrap');

import { createApp } from 'vue'

import Transaction from './components/Transaction';
//import Report from './pages/reports/components/Report.vue'
//import PrimeVue from "primevue/config"; 
//import Aura from '@primevue/themes/aura';



import VueSweetalert2 from 'vue-sweetalert2';
import VueNumberFormat from '@coders-tm/vue-number-format'
import 'sweetalert2/dist/sweetalert2.min.css';

const app=createApp();

app.use(VueNumberFormat, { precision: 2})
app.use(VueSweetalert2);
/*app.use(PrimeVue, {
    theme: {
        preset: Aura
    }
});*/
app
    .component('transaction', Transaction)
    //.component('report', Report)
    .mount('#app');
